// ------------ Font ----------- //

export const montserrat = "'Montserrat', 'Helvetica', sans-serif";
export const fontWeightRegular = '400';
export const fontWeightSemiBold = '600';
export const fontWeightBold = '700';
